import { useContext, useEffect } from "react";
import { toast, Zoom } from "react-toastify";

import { useDispatch, useSelector } from "react-redux";
import { SharedContext } from "context/SharedContext";
import { actionCleanMessage, selectSharedState } from "redux/shared/SharedSlice";

const CONFIG_MESSAGE = {
  position: "bottom-right",
  autoClose: 5000,
  // icon: false,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

const Toast = () => {
  const oDispatch = useDispatch();
  const { bDarkTheme } = useContext(SharedContext);

  const { sMessage, sMessageType } = useSelector(selectSharedState);

  useEffect(() => {
    if (sMessage) {
      toast(sMessage, {
        ...CONFIG_MESSAGE,
        type: sMessageType,
        theme: bDarkTheme ? "dark" : "light",
        transition: Zoom,
      });
      oDispatch(actionCleanMessage());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sMessage]);

  return null;
};

export default Toast;
